import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';

export default function RichTextEditor({ value }) {
  return <ReactQuill theme='bubble' value={value} readOnly />;
}
